// extracted by mini-css-extract-plugin
export default {"main":"Toggle_main__I2VTp","toggle":"Toggle_toggle__lf-Vn","cbx":"Toggle_cbx__0gzLd"};